import type { IApplicationInsights } from '@microsoft/applicationinsights-web';
import type { InjectionKey } from 'vue';

export const appInsightsInjectionKey = Symbol(
    'vue-application-insights-injection-key'
) as InjectionKey<IApplicationInsights>;
